import { css } from 'aphrodite';
import * as React from 'react';
import { useSuccessInboxRepsQuery } from '../../../../queries/Admin/SuccessInbox';
import { Button } from '../../../../web/components-v2/Button';
import { useAdminUserSession } from '../../../../models/hooks/adminStateHooks';
import { SuccessInboxThreadList } from '../SuccessInboxThreadList';
import { styleSheet } from './styles';

export const SuccessInbox: React.FC = () => {
	const userSession = useAdminUserSession();
	const repsQuery = useSuccessInboxRepsQuery();

	const currentUserId = userSession?.user?.id ?? '';
	const reps = repsQuery.data ?? [];

	const [selectedUserId, setSelectedUserId] = React.useState('');

	const viewerIsARep = reps.some(rep => rep.userId === currentUserId);

	// Opening on the viewer's own inbox is only useful if they have one. An admin who is not a Success
	// rep would otherwise land on a permanently empty list that reads as a broken page.
	const activeUserId = selectedUserId || (viewerIsARep ? currentUserId : (reps[0]?.userId ?? ''));

	if (repsQuery.isLoading) {
		return <div className={css(styleSheet.message)}>Loading…</div>;
	}

	if (repsQuery.isError) {
		return (
			<div className={css(styleSheet.message)}>
				Could not work out whose inboxes are in scope, so nothing is shown. Try again in a moment.
			</div>
		);
	}

	return (
		<div className={css(styleSheet.container)}>
			<div className={css(styleSheet.header)}>
				<h2 className={css(styleSheet.heading)}>Success Inbox</h2>
				<span className={css(styleSheet.message)}>
					Client email, triaged as it arrives. Acting on a thread clears it from this list.
				</span>
			</div>

			{reps.length > 0 ? (
				<div className={css(styleSheet.repPicker)}>
					{viewerIsARep ? (
						<Button
							onClick={() => setSelectedUserId('')}
							size='sm'
							variant={activeUserId === currentUserId ? 'primary' : 'outline'}
						>
							Mine
						</Button>
					) : null}
					{reps
						.filter(rep => rep.userId !== currentUserId)
						.map(rep => (
							<Button
								key={rep.userId}
								onClick={() => setSelectedUserId(rep.userId)}
								size='sm'
								variant={activeUserId === rep.userId ? 'primary' : 'outline'}
							>
								{rep.name}
							</Button>
						))}
				</div>
			) : null}

			{activeUserId ? (
				<SuccessInboxThreadList userId={activeUserId} />
			) : (
				<div className={css(styleSheet.message)}>
					Nobody is in scope yet, so there is no inbox to show. Set the pilot group to put reps in scope.
				</div>
			)}
		</div>
	);
};
